import { render } from "./ProgramSettingsContent.vue?vue&type=template&id=efe473ae&scoped=true"
import script from "./ProgramSettingsContent.vue?vue&type=script&lang=js"
export * from "./ProgramSettingsContent.vue?vue&type=script&lang=js"

import "./ProgramSettingsContent.vue?vue&type=style&index=0&id=efe473ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe473ae"]])

export default __exports__